export default __webpack_public_path__ + "static/media/pyflask.56b707d6.jpg";